// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujVieServeur.js
//  le rapport de vie du serveur
//
//  Sorti de SujPanel.js le 7 aout 2026. Le JSX est celui d'origine,
//  deplace au caractere pres ; les props sont calculees par analyse
//  de portee, pas devinees.
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export function SujVieServeur({ carte, isMobile, vieServeur }) {
  return (
    <>
      {/* ── 2. VIE DU SERVEUR (rapport simple, sans tâche) ──────────── */}
      {vieServeur.length > 0 && (
        <div style={carte()}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
            <div style={{ color: "#6FD3C7", fontSize: 12, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase" }}>🤝 Vie du serveur</div>
            <span style={{ color: THEME.textDim, fontSize: 10 }}>ce que les joueurs se racontent — aucune tâche créée</span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fill, minmax(280px, 1fr))", gap: 8 }}>
            {vieServeur.map((v) => (
              <div key={v.id} style={{ background: THEME.surface, borderRadius: 8, padding: "9px 12px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ color: THEME.text, fontSize: 12, fontWeight: 600, flex: 1 }}>{v.titre}</span>
                  <span style={{ color: "#6FD3C7", fontSize: 12, fontWeight: 700 }}>{v.occurrences}</span>
                </div>
                {v.description && <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 3, lineHeight: 1.45 }}>{v.description}</div>}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
